import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsEnums} from "../../shared/dto/aps.enums";
import {apsCommon} from "../../shared/dto/aps.common";
import * as angular from "angular";
import * as _ from "lodash";
import {Plant} from "../../models/navigation";
import HttpServiceName, {HttpService} from "../http/http.service";
import {Endpoints} from "../../shared/config/constant.module";

export interface PlantLocation extends apsCommon.IdAndNameBase {
  locationType: apsEnums.LocationType;
  location?: apsViewModels.LocationNavigation;
  parent?: PlantLocation;
  children: PlantLocation[];
}

export interface LocationsService {
  initialize(): angular.IPromise<any>;
  getOtherLocations(): apsCommon.IdAndName[];
  getPlantLocations(plant: Plant, locations?: apsViewModels.LocationNavigation[]): PlantLocation[];
}

class LocationsServiceImpl implements LocationsService {
  private locations: apsCommon.IdAndName[];
  private httpService: HttpService;
  private $q: angular.IQService;

  constructor(httpService: HttpService,
              $q: angular.IQService) {
    this.httpService = httpService;
    this.$q = $q;
  }

  initialize(): angular.IPromise<any> {
    if (this.locations) {
      return this.$q.when(this.getOtherLocations());
    }
    return this.httpService.get(Endpoints.LOCATIONS)
      .then((data: apsCommon.IdAndName[]) => this.locations = data);
  }

  getOtherLocations(): apsCommon.IdAndName[] {
    return this.locations.concat();
  }

  getPlantLocations(plant: Plant,
                    locations?: apsViewModels.LocationNavigation[]): PlantLocation[] {
    let plantLocations: PlantLocation[] = [];

    let plantLocation: PlantLocation = {
      id: null,
      name: 'Plant',
      locationType: apsEnums.LocationType.Plant,
      children: []
    };

    if (plant) {
      plantLocation.id = plant.id;
      plantLocations.push(plantLocation);
      _.forEach(plant.tanks, (t: apsViewModels.TankNavigation) => {
        let tankLocation: PlantLocation = {
          id: t.id,
          name: 'Tank ' + t.name,
          locationType: apsEnums.LocationType.Tank,
          children: [],
          parent: plantLocation
        };
        plantLocation.children.push(tankLocation);
        plantLocations.push(tankLocation);
        _.forEach(t.shops, (s: apsViewModels.ShopNavigation) => {
          let shopLocation: PlantLocation = {
            id: s.id,
            name: 'Shop ' + s.name,
            locationType: apsEnums.LocationType.Shop,
            children: [],
            parent: tankLocation
          };
          plantLocation.children.push(shopLocation);
          tankLocation.children.push(shopLocation);
          plantLocations.push(shopLocation);
        });
      });
    }

    _.forEach(this.locations, (l: apsCommon.IdAndName) => {
      let otherLocation: PlantLocation = {
        id: l.id,
        name: l.name,
        locationType: apsEnums.LocationType.Other,
        parent: plantLocation,
        children: []
      };
      plantLocation.children.push(otherLocation);
      plantLocations.push(otherLocation);
    });

    if (locations) {
      _.forEach(plantLocations, (l: PlantLocation) => {
        l.location = _.find(locations, {locationType: l.locationType, locationTypeId: l.id});
      });
    }

    return plantLocations;
  }
}

export default angular
  .module('aps.services.locations', [HttpServiceName])
  .service('locationsService', LocationsServiceImpl)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/locations/locations.service.ts